import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/index.vue'),
    meta: { 
      title: '登录',
      noAuth: true // 不需要登录权限
    }
  },
  {
    path: '/',
    component: () => import('../layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import('../views/Dashboard.vue'),
        meta: { 
          title: '首页概览'
        }
      },
      {
        path: '/product/list',
        name: 'ProductList',
        component: () => import('../views/product/ProductList.vue'),
        meta: { 
          title: '商品列表'
        }
      },
      {
        path: '/product/category',
        name: 'ProductCategory',
        component: () => import('../views/product/ProductTypeList.vue'),
        meta: { 
          title: '商品分类'
        }
      },
      {
        path: '/order/list',
        name: 'OrderList',
        component: () => import('../views/order/OrderList.vue'),
        meta: { 
          title: '订单列表'
        }
      },
      {
        path: '/user',
        name: 'UserList',
        component: () => import('../views/user/UserList.vue'),
        meta: { 
          title: '用户管理'
        }
      },
      {
        path: '/banner',
        name: 'BannerList',
        component: () => import('../views/banner/BannerList.vue'),
        meta: { 
          title: '轮播图管理'
        }
      },
      {
        path: '/system/admin',
        name: 'AdminList',
        component: () => import('../views/system/AdminList.vue'),
        meta: { 
          title: '管理员管理'
        }
      },
      {
        path: '/system/config',
        name: 'SystemConfig',
        component: () => import('../views/system/SystemConfig.vue'),
        meta: { 
          title: '系统配置'
        }
      },
      {
        path: '/attachment/list',
        name: 'AttachmentList',
        component: () => import('../views/attachment/AttachmentList.vue'),
        meta: { 
          title: '附件管理'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  
  // 设置页面标题
  document.title = to.meta.title ? `${to.meta.title} - 商城管理系统` : '商城管理系统'
  
  // 如果没有token且访问的不是登录页，重定向到登录页
  if (!token && !to.meta?.noAuth) {
    next('/login')
  } else if (token && to.path === '/login') {
    // 如果已登录且访问登录页，重定向到首页
    next('/dashboard')
  } else {
    next()
  }
})

export default router
